import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState, useMemo} from "react";

import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";

import axiApi from "ApiCaller";
import TableSender from "./sender/TableSender";
import FilterSender from "./sender/FilterSender";
import FormSender from "./sender/FormSender";
import ModalSelectorSender from "./sender/ModalSelectorSender";
import ModalSendCommand from "./sender/ModalSendCommand";
import ModalSendMessage from "./sender/ModalSendMessage";
import navs from "./navs";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ConditionalRender from "components/ConditionalRender";
import OrderingModel from "components/ordering/OrderingModel";
import NavBreadcrum from "components/NavBreadcrum";
import {NetworkSyncModel} from "site-apps/devices/networks/NetworkSyncModel";
import useCustomTranslation from "core/customTranslation";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import translations from "./sender/translations";
import ItemsModel from "core/itemsModel";

const buttonsActions = {
    title: "",
    edit: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
    send: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
    command: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
    sendMessage: {
        active: true,
        disabled: false,
        onClick: () => {},
    },
};
const ParamsDefaults = {
    models: [],
    configs: [],
    device_groups: [],
    asset_groups: [],
    islands: [],
    routes: [],
};
const ViewSender = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);

    document.title = _Tr("labels.send");
    const bread = useMemo(
        () => [
            {
                name: _Tr("labels.advanced"),
                url: "/advanced/",
                current: false,
            },
            {name: document.title, current: true},
        ],
        [_Tr],
    );
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const QuestionWarning = new SwalAlertChoice({
        iconColor: "#ddb655",
        confirmButtonText: _Tf("labels.accept"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const QuestionInfo = new SwalAlertChoice({
        iconColor: "#55c9dd",
        confirmButtonText: _Tf("labels.accept"),
        cancelButtonText: _Tf("labels.cancel"),
    });

    const mode = useRef("");
    const items = useRef({...new ItemsModel()});
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [item, setItem] = useState({...NetworkSyncModel});
    const [checkedAll, setCheckedAll] = useState(false);
    const [params, setParams] = useState({...ParamsDefaults});
    const [buttonsTB, setButtonsTB] = useState({
        ...buttonsActions,
        title: document.title,
    });
    const [isLoading, setIsLoading] = useState(false);
    // data table
    const [itemsShown, setItemsShown] = useState([]);
    const [showCanvas, setShowCanvas] = useState(false);
    const [modalSender, setModalSender] = useState(false);
    const [modalCommand, setModalCommand] = useState(false);
    const [modalMessage, setModalMessage] = useState(false);
    const [showPrev, setShowPrev] = useState(false);

    const headersTable = [
        {
            name: (
                <>
                    {_TC("table.header.uuid")}
                    <br />
                    {_TC("table.header.model")}
                </>
            ),
            attr: 0,
            direction: "asc",
            active: true,
            default: true,
        },
        {
            name: (
                <>
                    {_TC("table.header.config")}
                    <br />
                    {_TC("table.header.actual")}
                </>
            ),
            attr: 1,
            direction: "asc",
            active: false,
        },
        {name: _TC("table.header.config"), attr: 2, direction: "asc", active: false, disabled: true},
        {name: _TC("table.header.params"), attr: 3, direction: "asc", active: false, disabled: true},
        {name: _TC("table.header.updated"), attr: 4, direction: "asc", active: false},
        {name: _TC("table.header.status"), attr: 5, direction: "asc", active: false},
        {name: _TC("table.header.queue"), attr: 6, direction: "asc", active: false},

    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.send.disabled = true;
        buttons.send.onClick = onClickSend;
        buttons.command.disabled = true;
        buttons.command.onClick = onClickCommand;
        buttons.sendMessage.disabled = false;
        buttons.sendMessage.onClick = () => setModalMessage(true);
        setButtonsTB(buttons);
        items.current.items = [];
        // -
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchPostData();
        };
        filters.current.filter = () => {
            pagerModelRef.current.paging.page = 1;
            fetchPostData();
        };
        subscribeEvent("reload:view:sender", reloadPage);
        setIsLoading(true);
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchPostData();
        items.current.item = NetworkSyncModel;
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        fetchGetData();
        setIsLoading(false);
        return () => {
            unsubscribeEvent("reload:view:sender", reloadPage);
        };
    }, []);

    const fetchGetData = async (filtersToApply) => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get("/api/devices/networks/sync/");
            if (resp.data) {
                items.current.showed = [...resp.data.items];
                items.current.clearChosen();
                setItemsShown([...resp.data.items]);
                setParams({...resp.data.params});
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchPostData = async (filtersToApply) => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post("/api/devices/networks/sync/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            });
            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                pagerModelRef.current.paging.setPager(resp.data);
                handleButtons();
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
        setIsLoading(false);
    };
    const handleButtons = () => {
        const buttons = {...buttonsTB};
        const disabled = items.current.items.length === 0;
        buttons.edit.disabled = disabled;
        buttons.send.disabled = disabled;
        buttons.command.disabled = disabled;
        setButtonsTB(buttons);
    };

    const reloadPage = () => {
        //const checkboxes = document.querySelectorAll('#data-list input[type="checkbox"]');
        //checkboxes.forEach((checkbox) => (checkbox.checked = false));
        fetchPostData();
        const disabled = items.current.chosen.length === 0;
        const buttons = {...buttonsTB};
        buttons.edit.disabled = disabled;
        buttons.send.disabled = disabled;
        buttons.command.disabled = disabled;
        setButtonsTB(buttons);
    };

    const onClickSend = async (e) => {
        // ← Sin async
        let queueBusy = 0;
        let indexes = items.current.chosen
            .map((uuid) => items.current.showed.findIndex((item) => item.uuid === uuid))
            .filter((index) => index !== -1);
        indexes.forEach((idx) => {
            if (items.current.showed[idx].queue) {
                queueBusy++;
            }
        });
        if (queueBusy > 0) {
            const quest = await QuestionWarning.question(_TC("question.all.title") + queueBusy, _TC("question.all.text"));
            if (!quest.isConfirmed) {
                return false;
            }
        }
        const resp = await QuestionInfo.question(
            _TC("question.send.title") + items.current.items?.length || "-",
            _TC("question.send.text"),
        );

        if (resp.isConfirmed) {
            setModalSender(true);
        }
    };

    const onClickEdit = (e) => {
        items.current.chosen.length === 1
            ? setItem(items.current.showed.find((item) => items.current.items[0].uuid === item.uuid))
            : setItem({...NetworkSyncModel});
        setShowCanvas(true);
    };

    const onClickCommand = (e) => {
        let select = [];
        items.current.items.forEach((item) => {
            if (!select.includes(item.mode)) {
                select.push(item.mode);
            }
        });
        if (select.length > 1) {
            Alert.error(_TC("message.error.title"), _TC("message.error.models"));
            return false;
        }
        mode.current = select[0];
        setModalCommand(true);
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <FilterSender params={params} items={items} actions={buttonsTB} filters={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="142px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableSender
                            items={items}
                            itemsShow={itemsShown}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
            <ConditionalRender condition={showCanvas}>
                <FormSender
                    item={item}
                    items={items}
                    showCanvas={showCanvas}
                    setShowCanvas={setShowCanvas}
                    setItemsShown={setItemsShown}
                />
            </ConditionalRender>
            <ConditionalRender condition={modalSender}>
                <ModalSelectorSender show={modalSender} setShow={setModalSender} items={items} />
            </ConditionalRender>
            <ConditionalRender condition={modalCommand}>
                <ModalSendCommand show={modalCommand} setShow={setModalCommand} items={items} mode={mode} />
            </ConditionalRender>
            <ConditionalRender condition={modalMessage}>
                <ModalSendMessage show={modalMessage} setShow={setModalMessage} items={items} mode={mode} />
            </ConditionalRender>
        </>
    );
};
export default ViewSender;
